import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { patchDocumentIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useUnpinDocumentMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((documentId: number) =>
			patchDocumentIdV2({ unassign: true }, documentId),
		),
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: DocumentKeys.allLists });
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.all });
		},
	});
};
